import React from 'react'
import styles from './Careers.module.css'

const Careers = props => {
  return (
    <div className={styles.careers}>
      <h3>Careers</h3>
      <p>
        There are currently no openings, but resumes may be submitted to <a href="mailto:inquiries@dom-sys.com">inquiries@dom-sys.com</a>
      </p>
    </div>
  )
}

export default Careers


// WEBPACK FOOTER //
// ./src/components/Careers/Careers.js